<template>
	<div v-if="isLoading" class="d21-loader" :class="{ activeFixed: isLoadingFixed, activeRelative: isLoadingRelative }">
		<div class="animation">
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
	</div>
	<div v-else>
		<slot />
	</div>
</template>

<script>
	import {
		EventBus
	} from "../../scripts/_eventBus.js";

	/**
	 * Loader component that consumes EventBus events.
	 * Displays a loading animation while the application is loading.
	 * Can be used with a slot to show that content when loading is finished.
	 */
	export default {
		name: "d21-loader",
		data() {
			return {
				isLoadingFixed: false,
				isLoadingRelative: false
			};
		},
		computed: {
			isLoading() {
				return this.isLoadingFixed || this.isLoadingRelative;
			}
		},
		created: function () {
			EventBus.$on("loading_start", data => {
				this.isLoadingFixed = true;
			});

			EventBus.$on("loading_end", data => {
				this.isLoadingFixed = false;
			});

			// postal code loading status
			EventBus.$on("postalcode_loading_start", data => {
				this.isLoadingRelative = true;
			});

			EventBus.$on("postalcode_loading_end", data => {
				this.isLoadingRelative = false;
			});
		}
	};
</script>